@import "config";

.checkbox {
	@include flex(row, unset, baseline);
	input {
		margin-right: $spacing-inset-nano;
	}
}
